import ajax from './ajax'

/**
 * 获取房产属性
 */
export const queryHouseAttrs = (params) => {
  const url = '/public/v1/home/attribute/' + params.houseNavId
  delete params.houseNavId
  return ajax({
    url: url,
    params: params
  })
}

/**
 * 获取房产信息列表
 */
export const queryHouseList = (params) => {
  const houseListApis = {
    '218': {
      'info': '/public/v1/home/new_info_list',
      'demand': '/public/v1/home/new_demand_list'
    },
    '219': {
      'info': '/public/v1/home/second_hand_info_list',
      'demand': '/public/v1/home/second_hand_demand_list'
    },
    '220': {
      'info': '/public/v1/home/new_info_list',
      'demand': '/public/v1/home/new_demand_list'
    }
  }
  const url = houseListApis[params.sn][params.tab]
  delete params.sn
  delete params.tab
  return ajax({
    url,
    params
  })
}

/**
 * 获取房产信息详情
 */
export const queryHouseDetail = (params) => {
  return ajax({
    url: '/public/v1/home/new_building_details/' + params.id
  })
}

/**
 * 新房留言列表
*/
export const queryComments = (params) => {
  return ajax({
    url: `/public/v1/home/list_new_house_message/${params.id}/${params.page}`
  })
}

/**
 * 新房楼盘 单个留言回复列表
*/
export const queryRecomments = (params) => {
  return ajax({
    url: `/public/v1/home/more_list_new_house_message/${params.id}/${params.commentId}/${params.page}`
  })
}

/**
 * 新房楼盘留言
*/
export const addComment = (params) => {
  return ajax({
    method: 'post',
    url: `/public/v1/home/post_msg`,
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 新房楼盘回复留言
*/
export const addRecomment = (params) => {
  return ajax({
    method: 'post',
    url: `/public/v1/home/post_reply_msg`,
    data: {
      ...params,
      withToken: 1
    }
  })
}



// WEBPACK FOOTER //
// ./src/axios/house.js